import {Component, Input, OnInit} from '@angular/core';
import {PlateMode} from "../../../../enums/PlateMode";
import {WorkflowInstanceModel} from "../../../../models/workflow/workflow-instance.model";
import {
  WorkflowStepMeasurementOnGlomaxFirstModel
} from "../../../../models/workflow-step/workflow-step-measurement-on-glomax-first.model";
import {PositionModel} from "../../../../models/Plate/position.model";
import {WorkflowDetailClientService} from "../../../dialog/workflow-detail-dialog/workflow-detail-client.service";
import {AbstractControl, UntypedFormArray, UntypedFormGroup} from "@angular/forms";
import {BatchModel} from "../../../../models/batch/batch.model";
import {BatchType} from "../../../../enums/BatchType";
import {WorkflowInstanceStepGlomaxService} from "../../../../services/workflow-instance-step-glomax.service";
import {BatchUtils} from "../../../../utils/batch.utils";

@Component({
  selector: 'app-measurement-on-glomax-first',
  templateUrl: './measurement-on-glomax-first.component.html',
  styleUrls: ['./measurement-on-glomax-first.component.scss']
})
export class MeasurementOnGlomaxFirstComponent implements OnInit {

  PlateMode = PlateMode;
  private isInitializing: boolean = true;

  @Input() workflowInstance: WorkflowInstanceModel;
  @Input() workflowStep: WorkflowStepMeasurementOnGlomaxFirstModel;
  @Input() readOnly: boolean = false;

  selectedPosition: PositionModel;

  batchFormArray: UntypedFormArray;
  batchTypes: BatchType[] = [];
  BatchType = BatchType;

  constructor(private workflowDetailClientService: WorkflowDetailClientService,
              private workflowInstanceStepGlomaxService: WorkflowInstanceStepGlomaxService) {
  }

  ngOnInit(): void {
    this.batchTypes = BatchType.getAllForGlomax();
    this.batchFormArray = BatchUtils.initBatchFormArray(this.workflowStep.batches, this.batchTypes, this.readOnly);
    this.validateStep();
    this.isInitializing = false;
  }

  getFormGroupFromAbstractControl(form: AbstractControl): UntypedFormGroup {
    return form as UntypedFormGroup;
  }

  onCellClick(position: PositionModel) {
    this.selectedPosition = position;
  }

  onFilesAdded(fileList: FileList) {
    this.workflowInstanceStepGlomaxService.manuallyAddFileByWorkflowInstanceId(this.workflowInstance.id, this.workflowStep.step, fileList)
      .subscribe(resp => {
        this.workflowStep = resp as WorkflowStepMeasurementOnGlomaxFirstModel;
        this.workflowDetailClientService.selectedStep$.next(this.workflowStep);
      });
  }

  validateStep(): void {
    this.workflowStep.batches = BatchModel.getBatchesFromBatchSelectionFormArray(this.batchFormArray);
    this.workflowDetailClientService.isStepValid$.next(this.workflowStep.isValid());

    // Save the current state when changes occur to prevent data loss
    if (!this.readOnly && !this.isInitializing) {
      this.workflowDetailClientService.silentSave();
    }
  }

}
